
export class OrderPaymentsDTO {
  type: string;
  description: string;
  orders: number;
  total: number;
  deliveryFee: number;
  processingFee: number;
  settledAmount: number;
  fxCurrencyAmount?: number;
  fxCurrencyId?: number;
  defaultCurrencyId?: number;
  posDeviceId: number;
  merchantId: number;
  isCash: number;
  isCard: number;
  isIntegration: number;
  isOtherPayment: number;
  isDepositPayment: number;
  isGiftCard?: number;
  isWebGiftCards?: number;
  isWebPos?: number;
  applicationSourceName?: string;
  applicationSourceId?: number;
}
